export const Footer = () => {
    return (
        <div className="border-white/40">
            <footer className="text-center text-xs text-muted-foreground pb-4">
                Pointo v{import.meta.env.VITE_APP_VERSION}
            </footer> 
        </div>
    );
};
